module.exports = __webpack_public_path__ + "static/media/37.67110075.mp4";